export const SYSTEM_TYPES = {
  THERAPIST_CONTENT_LIMIT: 'therapist_content_limit'
};
